import React from 'react'

const ProductPena = () => {
  return (
    <main>
      {/* Hero Area Start */}
      <div
        className="hero-area hero-height2 d-flex align-items-center"
        data-background="assets/img/hero/h2_hero.jpg"
      >
        <div className="container">
          <div className="row">
            <div className="col-xl-12">
              <div className="hero-cap text-center pt-50">
                <h2>PENA</h2>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Hero Area End */}
      {/* Our Services Start */}
      <div className="our-services section-padding2">
        <div className="container">
          <div className="row">
            <h1>This Page Is Under Construction.</h1>
          </div>
        </div>
      </div>
      {/* Our Services End */}
      {/* Want To Work Start */}
      <div className="wantToWork-area wantToWork-area2 w-padding2">
        <div className="container">
          <div className="row align-items-center justify-content-between">
            <div className="col-xl-8 col-lg-8 col-md-8">
              <div className="wantToWork-caption wantToWork-caption2">
                <h2>
                  Segera hubungi kami dan buat bisnis anda menjadi digital
                  dengan kami.
                </h2>
              </div>
            </div>
            <div className="col-xl-4 col-lg-4 col-md-4">
              <a href="/contact" className="btn btn-black f-right">
                contact us now
              </a>
            </div>
          </div>
        </div>
      </div>
      {/* Want To Work End */}
    </main>
  )
}

export default ProductPena
